import { h, Component } from 'preact'
import { Text } from 'preact-i18n'

export default class extends Component {

    constructor(props) {
        super(props)

        this.onChange = (e, {item: {value}}) => {
            this.context.form.setValue(this.props.name)(value)
        }
    }

    componentDidMount() {
        // if (!this.initialized) jQuery(this.select).selectmenu({
        //     select: this.onChange
        // })
        jQuery(this.select).selectpicker()
        this.initialized = true
    }

    componentWillUpdate() {
        // if (this.initialized) jQuery(this.select).selectmenu( 'destroy' )
        jQuery(this.select).selectpicker('destroy')
        this.initialized = false
    }

    componentDidUpdate() {
        // if (!this.initialized) jQuery(this.select).selectmenu({
        //     select: this.onChange
        // })
        jQuery(this.select).selectpicker()
        this.initialized = true
    }

    componentWillUnmount() {
        // if (this.initialized) jQuery(this.select).selectmenu( 'destroy' )
        jQuery(this.select).selectpicker('destroy')
        this.initialized = false
    }

    render ({name, label, required, options = []}, state, context) {
        let error = context.form.error[name]
        return (
            <div class={`form-group${error ? ' parsley-error' : ''}`}>
                <label class="control-label" for={name}><Text id={label} />{required && '*'}</label>
                <div class="input">
                    <select 
                        ref = {x => this.select = x}
                        class="form-control"
                        id={name}
                        name={name}
                        onChange={e => context.form.setValue(name)(e.target.value)} 
                        onBlur={e => context.form.setValue(name)(e.target.value)} 
                    >
                        { options.map(({key, value}) =>
                            <option value={key} selected={key == context.form.data[name]}><Text id={value} /></option>
                        ) }
                    </select>
                    {error && 
                        <ul class="parsley-errors-list filled">
                            <li><Text id={ 'validationError.' + error }>{error}</Text></li>
                        </ul>
                    }
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./js/components/Form/Select.js